<template lang="pug">
.custom-export-fields(v-if="storyCustomFieldsStore.all.length > 0")
  hr
  Label(text="Custom Export Fields")
  ul.list-group
    li.list-group-item(v-for="field in storyCustomFieldsStore.all" :key="field.id")
      strong {{ field.name }}:
      |  {{ field.value || '(empty)' }}
</template>

<script>
  import { mapStores } from 'pinia'
  import { useStoryCustomFieldsStore } from '@/stores/story_custom_fields'
  import Label from '@/components/shared/label.vue'

  export default {
    components: {
      Label
    },

    props: {
      storyId: {
        type: Number,
        required: true
      }
    },

    computed: {
      ...mapStores(useStoryCustomFieldsStore)
    },

    mounted() {
      this.storyCustomFieldsStore.fetchForStory(this.storyId)
    }
  }
</script>

<style lang="scss" scoped>
  .list-group-item {
    padding: 8px 12px;
  }
</style>
